import apiClient from "../apiClient";
import { ENDPOINTS } from "../endpoints";

export const projectService = {
  list: async () => (await apiClient.get(ENDPOINTS.projects)).data,
  get: async (id) => (await apiClient.get(ENDPOINTS.project(id))).data,
  create: async (payload) => (await apiClient.post(ENDPOINTS.projects, payload)).data,
  update: async (id, payload) => (await apiClient.patch(ENDPOINTS.project(id), payload)).data,
  addMember: async (id, employeeId) =>
    (await apiClient.post(ENDPOINTS.projectMembers(id), { employee_id: employeeId })).data,
  removeMember: async (id, employeeId) =>
    (await apiClient.delete(ENDPOINTS.projectMember(id, employeeId))).data,
};

export const reportService = {
  get: async (name, params = {}) => (await apiClient.get(ENDPOINTS.report(name), { params })).data,
  // returns a Blob for direct download -- see ReportsPage for the download-trigger pattern
  export: async (name, format = "csv", params = {}) =>
    apiClient.get(ENDPOINTS.reportExport(name), { params: { ...params, format }, responseType: "blob" }),
};
